module.exports = __webpack_public_path__ + "img/SpawnerManagerSpawner.2b2f2e86.png";